import { mutatorAction } from 'satcheljs';
import { feedbackRibbonStore } from '../store/store';

export let initializeFeedbackRibbonState = mutatorAction(
    'initializeFeedbackRibbonState',
    (sessionId: string) => {
        feedbackRibbonStore.mountedRibbons.set(sessionId, {
            showThankYouMessage: false,
            showMoreFeedbackMessage: false,
            feedbackRibbonResponse: '',
        });
    }
);
